export const USEQUERY = false

export const USD = 'USD'

export const PURCHASE_CATEGORY = {
  MONTHLY: 'monthly',
  UPFRONT: 'upfront',
}

export const ROUTES = {
  FORGOTPASSWORD: '/forgotpassword',
  REGISTER: '/register',
  SCHOOL_STORE: 'schoolstore',
  PENDING: '/status/pending',
  MAINTENANCE: 'maintenance',
  REJECTED: '/status/rejected',
  LOCKED: '/locked',
  LOGIN: '/login',
  ACCESSIBLE_PROGRAMS: '/sis/accessibleprograms',
  LOGINBASE: '/loginbase',
  ALLPROGRAMSOPEN: '/allprograms',
  PROGRAMDETAILOPEN: '/programdetailsopen',
  SURVEYDETAIL: '/sis/mysurveys/surveydetail',
  PARENTSURVEYDETAIL: '/sis/mysurveys/surveydetail',
  DASHBOARD: '/sis/dashboard',
  PROGRAMCOURSES: '/sis/availableprograms',
  // PARENTPROGRAMDETAILS: '/sis/programcourses/programdetails',
  ALLENROLLMENTS: '/sis/enrollments',
  ENROLLMENTDETAILS: '/sis/enrollments/enrollmentdetails',
  PROGRAM_DETAILS: '/sis/enrollments/details',
  ADD_ON_PROGRAM_DETAILS: '/sis/enrollments/details',
  ENROLLEDCOURSES: '/sis/enrollments/courses',
  ADD_ON_PURCHASE: '/sis/enrollments/addons',
  SUCCESS_COACHES: 'sis/enrollments/coaches',
  ADDITIONAL_FEE: 'sis/enrollments/additionalfee',
  POST_GRADUATION_PLAN: 'sis/enrollments/postgraduationplans',
  AVAILABLEPROGRAMDETAILS: '/sis/availableprograms/programdetails',
  MYPROFILE: '/sis/myprofile',
  PAYMENT: '/sis/payment',
  PAYMENT_FUNDED: '/sis/payment_funded',
  TRANSACTIONS: '/sis/transaction/alltransactions',
  // SETTINGS: '/sis/settings',
  // ANNOUNCEMENTS: '/sis/announcements/allannouncements',
  ANNOUNCEMENTSDETAILS: '/sis/announcements/announcementdetails',
  NOTFOUNDROOT: '/notfound',
  NOTFOUND: '/sis/notfound',
  PARENTSSTUDENTDASHBOARD: '/sis/studentviewdashboard',
  PARENTSTUDENTPROFILE: '/sis/studentviewprofile',
  PARENTALLTRANSACTION: 'sis/transaction/alltransactions',
  MESSAGECENTER: 'sis/messagecenter',
  CALENDAR: 'sis/calendar',
  CONTACT: 'sis/contact',
  RESOURCES: 'sis/resources',
  COMMUNITY: 'sis/community',
  ALLTICKETS: 'sis/tickets',
  CREATETICKET: 'sis/createticket',
  TICKETDETAILS: 'sis/ticketdetails',
  ARCHIVEDTICKETS: 'sis/archivedtickets',
  ARCHIVEDTICKETDETAILS: 'sis/archivedtickets/ticketdetails',
  ENROLLMENT_PAYMENT_DETAILS: 'sis/enrollments/payment',
  UPDATE_PROFILE: 'sis/updateprofile',
  ENROLLMENT: 'sis/enrollment/success',
  SUBMISSIONS: '/submissions',
  LMS: 'sis/lms/dashboard',
  STUDENT_ANNOUNCEMENT: 'sis/announcements',
  PARENT_ANNOUNCEMENT: 'sis/announcements',
  STUDENT_EVENTS: 'sis/events',
  PARENT_EVENTS: 'sis/events',
  MESSAGING: 'sis/messaging',
  INBOX_MESSAGES: 'sis/messaging/inbox',
  SENT_MESSAGES: 'sis/messaging/sent',
  DRAFT_MESSAGES: 'sis/messaging/draft',
  TRASH_MESSAGES: 'sis/messaging/trash',
  COMMUNICATION: 'sis/communication',
  PARENT_INBOX_MESSAGES: 'sis/messaging/inbox',
  PARENT_SENT_MESSAGES: 'sis/messaging/sent',
  PARENT_DRAFT_MESSAGES: 'sis/messaging/draft',
  PARENT_TRASH_MESSAGES: 'sis/messaging/trash',
  PARENT_COMMUNICATION: 'sis/communication',
  STUDENT_SURVEY: 'sis/mysurveys',
  PARENT_SURVEY: 'sis/mysurveys',
}

export const MESSAGES_BULK_ACTION = {
  ARCHIVE: 'archive',
  DELETE: 'delete',
  UNARCHIVE: 'unArchive',
  READ: 'read',
  UNREAD: 'unread',
  RESTORE: 'restore',
}

export const EVENT_MEDIA_TYPES = {
  ATTACHMENT: 'EVENTS',
  THUMBNAIL: 'THUMBNAIL',
}

export const MESSAGE_SEVERITIES = {
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  SUCCESS: 'success',
}
export const ANNOUNCEMENT_MEDIA_TYPES = {
  ATTACHMENT: 'ANNOUNCEMENT',
  THUMBNAIL: 'THUMBNAIL',
}

export const PAYMENT_STATUS = {
  APPROVED: 'approved',
  PENDING: 'pending',
  CANCELLED: 'cancelled',
  REFUNDED: 'refunded',
  ABANDONED: 'abandoned',
}

export const RULE_TYPES = {
  NUMBER_OF_COURSES: 'by_number_of_courses',
  CREDIT_VALUE: 'by_total_credit_value',
  MAX_COURSE: 'by_max_course_selection',
  MAX_CREDIT: 'by_max_credit',
  MIN_MAX_COURSE: 'by_min_max_course_numbers',
}

export const REGISTERATION_STATUS = {
  INPROCESS: 'IN_PROCESS',
  APPROVED: 'APPROVED',
  DENIED: 'DENIED',
}

export const DEFAULTURL = {
  DEFAULT: 'default',
}

export const PAYMENT_TYPES = {
  SUCCESS: 'success',
  FAILURE: 'failure',
  REENROLLSUCCESS: 'reenrollsuccess',
  RENROLLFAILURE: 'reenrollfailed',
  WALLETSUCCESS: 'wallet_success',
  WALLETFAILURE: 'wallet_failure',
  PREPAYMENTFAILURE: 'prepaymentfailed',
  PREPAYMENTSUCCESS: 'prepaymentsuccess',
  ADDITIONALFEESUCCESS: 'additionalfeesuccess',
  ADDITIONALFEEFAILURE: 'additionalfeefailure',
  GUEST_CHECKOUT_SUCCESS: 'guestcheckoutsuccess',
  GUEST_CHECKOUT_FAILURE: 'guestcheckoutfailure',
}

export const COURSE_STATUS = {
  PASSED: 'passed',
  FAILED: 'failed',
  IN_PROGRESS: 'in_progress',
  PENDING: 'pending',
  UPCOMING: 'upcoming',
  PASSED_WITHOUT_GRADE: 'passed_without_grade',
  WITHDRAWN: 'withdrawn',
  IN_COMPLETE: 'in_complete',
}

export const NOTIFICATION_TYPE = {
  INAPPNOTIFICATIONENROLMENTPAYMENTFAILED: 'INAPP_NOTIFICATION_ENROLMENT_PAYMENT_FAILED',
  INAPPNOTIFICATIONCOURSEUPDATESTATUS: 'INAPP_NOTIFICATION_COURSE_UPDATE_STATUS',
  INAPPNOTIFICATIONENROLMENTUPDATESTATUS: 'INAPP_NOTIFICATION_ENROLMENT_UPDATE_STATUS',
  INAPPNOTIFICATIONENROLMENTHOLDSTATUSUPDATE: 'INAPP_NOTIFICATION_ENROLMENT_HOLD_STATUS_UPDATE',
  INAPPNOTIFICATIONENROLMENTENROLLED: 'INAPP_NOTIFICATION_ENROLMENT_ENROLLED',
  INAPPNOTIFICATIONENROLMENTPAYMENTSUCCESS: 'INAPP_NOTIFICATION_ENROLMENT_PAYMENT_SUCCESS',
  INAPPNOTIFICATIONRECURRINGPAYMENT: 'INAPP_NOTIFICATION_RECURRING_PAYMENT',
  INAPPNOTIFICATIONPREPAYMENTFAILED: 'INAPP_NOTIFICATION_PRE_PAYMENT_FAILED',
  INAPPNOTIFICATIONPREPAYMENTSUCCESS: 'INAPP_NOTIFICATION_PRE_PAYMENT_SUCCESS',
  INAPPNOTIFICATIONADDITIONALFEEPAYMENTFAILED: 'INAPP_NOTIFICATION_ADDITIONAL_FEE_PAYMENT_FAILED',
  INAPPNOTIFICATIONADDITIONALFEEPAYMENTSUCCESS: 'INAPP_NOTIFICATION_ADDITIONAL_FEE_PAYMENT_SUCCESS',
  INAPPNOTIFICATIONADDITIONALFEECREATE: 'INAPP_NOTIFICATION_ADDITIONAL_FEE_CREATE',
  INAPP_NOTIFICATION_REFUND_FAILED: 'INAPP_NOTIFICATION_REFUND_FAILED',
  INAPP_NOTIFICATION_REFUND_SUCCESS: 'INAPP_NOTIFICATION_REFUND_SUCCESS',
  INAPPNOTIFICATIONREENROLMENTUPDATED: 'INAPP_NOTIFICATION_RE_ENROLMENT_UPDATED',
  INAPPNOTIFICATIONREENROLMENTCOMPLETED: 'INAPP_NOTIFICATION_COURSE_COMPLETED',
  INAPPNOTIFICATIONREENROLMENTENROLLED: 'INAPP_NOTIFICATION_RE_ENROLMENT_ENROLLED',
  INAPPNOTIFICATIONREENROLMENTFAILED: 'INAPP_NOTIFICATION_RE_ENROLMENT_FAILED',
  INAPPNOTIFICATIONREENROLMENTPAYMENTSUCCES: 'INAPP_NOTIFICATION_RE_ENROLMENT_PAYMENT_SUCCESS',
  INAPPNOTIFICATIONREENROLMENTPAYMENTFAILED: 'INAPP_NOTIFICATION_RE_ENROLMENT_PAYMENT_FAILED',
  INAPPNOTIFICATIONADDITIONALFEEUPDATED: 'INAPP_NOTIFICATION_ADDITIONAL_FEE_UPDATED',
  UPDATE_TICKET_STATUS: 'INAPP_NOTIFICATION_UPDATE_TICKET_STATUS',
  ARCHIVE_TICKET_STATUS: 'INAPP_NOTIFICATION_ARCHIVE_TICKET_STATUS',
  TICKET_ASSIGNEE_UPDATE: 'INAPP_NOTIFICATION_TICKET_ASSIGNEE_UPDATE',
  TICKET_DESCRIPTION_UPDATE: 'INAPP_NOTIFICATION_TICKET_DESCRIPTION_UPDATE',
  TICKET_PRIORITY_UPDATE: 'INAPP_NOTIFICATION_TICKET_PRIORITY_UPDATE',
  TICKET_CHANNEL_UPDATE: 'INAPP_NOTIFICATION_TICKET_CHANNEL_UPDATE',
  TICKET_COMMENT_UPDATE: 'INAPP_NOTIFICATION_TICKET_COMMENT_UPDATE',
  UNARCHIVE_TICKET_STATUS: 'INAPP_NOTIFICATION_UNARCHIVE_TICKET_STATUS',
  TICKET_CREATED: 'INAPP_NOTIFICATION_TICKET_CREATED',
  TICKET_COMMENT_CREATE: 'INAPP_NOTIFICATION_TICKET_COMMENT_CREATE',
  ALTERNATE_PROGRAM_TRACK_DISABLE: 'INAPP_NOTIFICATION_ALTERNATE_PROGRAM_TRACK_DISABLE',
  ALTERNATE_PROGRAM_TRACK_ENABLE: 'INAPP_NOTIFICATION_ALTERNATE_PROGRAM_TRACK_ENABLE',
  INAPP_NOTIFICATION_COURSE_SURVEY: 'INAPP_NOTIFICATION_COURSE_SURVEY',
  INAPP_NOTIFICATION_PROGRAM_SURVEY: 'INAPP_NOTIFICATION_PROGRAM_SURVEY',
  INAPP_NOTIFICATION_SCHOOL_SURVEY: 'INAPP_NOTIFICATION_SCHOOL_SURVEY',
  INAPP_NOTIFICATION_PARENT_SURVEY: 'INAPP_NOTIFICATION_PARENT_SURVEY',
}
// eslint-disable-next-line no-useless-escape
export const URN_TEMPLATE = /urn:([a-zA-Z0-9\/-]+):([a-zA-Z0-9\/-]+)::(.*)/
export const DATEFORMAT = 'MM/DD/YYYY'
export const DATEFORMATCALANDER = 'YYYY-MM-DD'
export const HOUR_MIN_FORMAT = 'HH:mm'
export const DATEFORMATPLACEHOLDER = 'MM/DD/YYYY'
export const DATEFORMATWITHTIME = 'MM/DD/YYYY HH:mm:ss'
export const DATETIMEFORMATPLACEHOLDER = 'MM/DD/YYYY HH:MM'
export const DATETIMEFORMATWITHCONSTANT = 'MM/DD/YYYY hh:mm A'
export const UsPhoneCode = '+1'
export const FAIL_CONSTANT = 'f'
export const SUCCESS_CONSTANT = 's'
export const STUDENT_AGE = 'student_age_for_parent_info'
export const TERMS_OF_USE = 'terms_of_use'
export const PRIVACY_POLICY = 'privacy_policy'
export const SCHOOL_GENDER = 'school_gender'
export const REENROLL_COURSES = 'reenroll_courses'
export const ENABLE_ESSAY = 'enable_essay'
export const ESSAY_QUESTION = 'essay_question'
export const STUDENT_APPROVAL = 'student_approval_required'
export const ENABLE_PROGRAM_SELECTION = 'enr_pgm_selection'
export const ON_MAINTENANNCE = 'on_maintenance'
export const SCHOOL_THEME = 'school_theme'
export const ENABLE_REGISTRATION_REVIEW = 'enable_registration_review'
export const ENABLE_PROFILE_PERCENTAGE = 'enable_profile_percentage'
export const ENABLE_WALLET = 'enable_wallet'
export const US_COUNTRY_CODE = 'US'
export const CANADA_COUNTRY_CODE = 'CA'
export const ANTIVIRUS_SCAN_FAILED = 'ANTIVIRUS_SCAN_FAILED'
export const SUPPORT_WIDGET_CODE = 'support_widget_code'
export const ENABLE_EVENT = 'enable_event'
export const ENABLE_FAMILY_LOGIN = 'enable_family_login'
export const ENABLE_SUCCESS_COACH = 'enable_success_coach'
export const IS_SHOW_GRADE_SCALE = 'is_show_graded_garde'
export const ENABLE_MODULE_PROGRESS = 'enable_module_progress'
export const OASES_SCHOOL_ID = 'oases_school_id'
export const AUTHORIZENET = 'authorizenet'
export const ANS_CUSTOMER_ID = 'ANS_customer_id'
export const GA_ENABLE = 'ga_enable'
export const GTM_ID = 'gtm_id'
export const GA_ID = 'ga_id'
export const ENABLE_CALENDAER = 'enable_calendar'
export const DOC_TYPE_TRANSCRIPT = 'transcript'
export const ERR_PROGRAM_IN_ACTIVE = 'ERR_PROGRAM_IN_ACTIVE'
export const DOC_TYPE_ID = 'id'
export const FILE_CATEGORY = 'file_category'
export const CANVAS = 'Canvas'
export const DROPPED = 'dropped'
export const ALL_ENROLLED = 'all_enrolled'
export const ENROLLED = 'enrolled'
export const PRIOR = 'prior'
export const REGULAR = 'REGULAR'
export const MESSAGE_URL = 'https://www.excelhighschool.com/online-store.php'
export const HELP_URL =
  'https://www.excelhighschool.com/blog/excel-high-school-enrollment-agreements'
export const YEARS = 'years'
export const CUSTOM_PAYMENT = 'custom-payment'
export const NUMBER_SYMBOLS = ['e', 'E', '+', '-', '.']

export const MENUITEMS = {
  DASHBOARD: 'Dashboard',
  ENROLLMENTS: 'Enrollments',
  PROGRAMS: 'Programs',
  ALLENROLLMENTS: 'All Enrollments',
  MYENROLLMENTS: 'My Enrollments',
  MYPROFILE: 'My Profile',
  BILLING: 'Billing',
  MESSAGE_CENTER: 'Message Center',
  CALENDAR: 'Calendar',
  RESOURCES_FORMS: 'Orientation/Resources',
  HELPDESK: 'Helpdesk',
  PROFILE: 'Profile',
  BACK: 'Back',
  CONTACT: 'Contact',
  PROGRAM_COURSES: 'Available Programs',
  SETTINGS: 'Settings',
  COMMUNITY: 'Community',
  PAYMENT: 'PAYMENT',
  PARENT_ANNOUNCEMENTS: 'Announcements',
  STUDENT_ANNOUNCEMENTS: 'Announcements',
  ONLINE_TUTORING: 'Online Tutoring',
  BILLING_DETAILS: 'Billing Details',
  LMS: 'LMS',
  MESSAGING: 'Messaging',
  PARENT_MESSAGING: 'Messaging',
  PARENT_EVENTS: 'Events & Calendar',
  STUDENT_EVENTS: 'Events & Calendar',
  COMMUNICATION: 'Communication',
  PARENT_COMMUNICATION: 'Communication',
  MYSURVEYS: 'My Surveys',
}

export const HOLDTYPES = {
  BILLING_HOLD: 'billing_hold',
  ATTENDANCE_HOLD: 'attendance_hold',
  ACADEMIC_HOLD: 'academic_hold',
  GRADUATION_HOLD: 'graduation_hold',
  NO_HOLD: 'no_hold',
  REENROLLMENT_HOLD: 're_enrollment_hold',
  SCHEDULING_HOLD: 'scheduling_hold',
  PHOTO_ID_HOLD: 'photo_id_hold',
  ADMIN_HOLD: 'admin_hold',
  DEADLINE_LOCKS: 'deadline_locks',
}

export const ENROLLMENTTYPES = {
  PENDING_PAYMENT: 'pending_payment',
  ENROLLED: 'enrolled',
  DECLINED_PAYMENT: 'declined_payment',
  DROPPED: 'dropped',
  LOCKED: 'locked',
  TRANSFERRED: 'transferred',
  INELIGIBLE: 'ineligible',
  EXPIRED: 'expired',
  COMPLETED: 'completed',
  NEW_UNPROCESSED: 'new_unprocessed',
  GRAD_EVALUATION: 'grad_evaluation',
  PACKAGE_PREPARATION: 'package_preparation',
  PRINTED: 'printed',
  GRADUATED: 'graduated',
  READY_FOR_REENROLLMENT: 'ready_for_re_enrollment',
  CANCELED: 'canceled',
  APPICATION: 'application',
  PREREQUISITE: 'pre_requisite',
  PENDING: 'pending',
  PRE_REQ_COMPLETED: 'pre_req_completed',
  GRADUATION_REVIEW: 'graduation_review',
}
export const PRIOR_PROGRAM_STATUS = [
  ENROLLMENTTYPES.GRADUATED,
  ENROLLMENTTYPES.TRANSFERRED,
  ENROLLMENTTYPES.DROPPED,
  ENROLLMENTTYPES.CANCELED,
]

export const REVIEW_PROGRAM_AS_PER_ENRSTATUS = [
  ENROLLMENTTYPES.GRAD_EVALUATION,
  ENROLLMENTTYPES.PRINTED,
  ENROLLMENTTYPES.GRADUATED,
  ENROLLMENTTYPES.GRADUATION_REVIEW,
]
export const LOCKED_PROGRAM_STATUS = [ENROLLMENTTYPES.LOCKED]
export const LOCK_COURSES_ENROLLMENT_STATUSES = [
  ENROLLMENTTYPES.DECLINED_PAYMENT,
  ENROLLMENTTYPES.DROPPED,
  ENROLLMENTTYPES.TRANSFERRED,
  ENROLLMENTTYPES.INELIGIBLE,
  ENROLLMENTTYPES.EXPIRED,
  // ENROLLMENTTYPES.COMPLETED,
  ENROLLMENTTYPES.GRAD_EVALUATION,
  ENROLLMENTTYPES.PRINTED,
  ENROLLMENTTYPES.GRADUATED,
  ENROLLMENTTYPES.READY_FOR_REENROLLMENT,
  ENROLLMENTTYPES.CANCELED,
]
export const REVIEW_SETTING_BOOLEAN_KEYS = [
  'enable_ratings',
  'publish_aggregated_ratings',
  'enable_review',
  'make_review_mandatory',
  'enable_review_moderation',
  'enable_email_review',
]
export const LOCK_COURSES_HOLD_STATUSES = [
  HOLDTYPES.BILLING_HOLD,
  HOLDTYPES.ACADEMIC_HOLD,
  HOLDTYPES.ADMIN_HOLD,
  HOLDTYPES.ATTENDANCE_HOLD,
  HOLDTYPES.GRADUATION_HOLD,
]
export const LOCK_TRANSCRIPT_ENROLLMENT_STATUSES = [ENROLLMENTTYPES.DECLINED_PAYMENT]
export const LOCK_TRANSCRIPT_HOLD_STATUSES = [
  HOLDTYPES.BILLING_HOLD,
  HOLDTYPES.ACADEMIC_HOLD,
  HOLDTYPES.PHOTO_ID_HOLD,
  HOLDTYPES.ADMIN_HOLD,
  HOLDTYPES.ATTENDANCE_HOLD,
  HOLDTYPES.GRADUATION_HOLD,
]
export const DROP_ENROLLMENT_LOCK_STATUSES = [
  ENROLLMENTTYPES.GRADUATED,
  ENROLLMENTTYPES.TRANSFERRED,
  ENROLLMENTTYPES.DROPPED,
  ENROLLMENTTYPES.LOCKED,
  ENROLLMENTTYPES.EXPIRED,
]

export const ADDITIONAL_FEE_STATUS = {
  FAILED: 'failed',
  PENDING: 'pending',
  COMPLETED: 'completed',
  ONGOING: 'ongoing',
}

export const TRANSACTION_REQUEST_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
}

export const TRANSACTION_TYPES = {
  ENROLLMENT: 'enrollment',
  ADDITIONAL_FEE: 'additional_fee',
  RE_ENROLLMENT: 're_enrollment',
}

export const FILE_TYPES = {
  DECLINED: 'declined',
  VERIFIED: 'verified',
  IN_REVIEW: 'in_review',
}
export const PROGRESSES_TYPES = {
  TERM_PROGRESS: 'term_progress',
  COURSE_PROGRESS: 'course_progress',
}
export const CUSTOMER_CREATE = 'customercore.users.create'
export const CUSTOMER_SET_PASSWORD = 'customercore.users.set-password'
export const CUSTOMER_LOGIN = 'customer.login'
export const TIMEFORMAT = 'HH:mm:ss'

export const TRANSACTION_STATUS = {
  APPROVED: 'approved',
  FAILED: 'failed',
  PENDING: 'pending',
  REFUNDED: 'refunded',
  ABANDONED: 'abandoned',
}
export const userDetailsInitialState = {
  gender: '',
  ethnicity: '',
  adr_mobile_prefix: UsPhoneCode,
  adr_mobile: '',
}

export const parentDetailsInitialState = {
  gender: '',
  ethnicity: '',
  dob: '',
}

export const PROGRAM_META_KEYS = {
  EXTENSION_FEE_DAYS: 'enable_extension_fee_days',
  EXTEND_PROGRAM_DAYS: 'extend_program_days',
  ENABLE_EXTENSION_FEE: 'enable_extension_fee',
  ENABLE_AUTO_APPROVE: 'enable_auto_approve',
  HIDE_REQUIRED_CREDITS: 'hide_required_credits',
  SKIP_PSM_GATEWAYS: 'skip_psm_gateways',
  ENABLE_INVOICE: 'enable_invoice',
}
export const ADDITIONALFEE_REQUEST_STATUS = {
  APPROVED: 'approved',
  PENDING: 'pending',
  REJECTED: 'rejected',
}

export const PROGRAM_TYPE = {
  PROGRAM: 'program',
  LIBRARY: 'library',
}

export const THEMES = {
  EHS: 'EHS',
}
export const FEE_TYPES = {
  TUTION: 'tuition',
  ADDITIONAL: 'additional',
}

export const ADDITIONAL_FEE_TYPES = {
  LATE_FEE: 'late_fee',
  EXTENSION_FEE: 'extension_fee',
}
export const RECIPIENT_TYPES = [
  {
    id: 'staff',
    value: 'Staff',
    name: 'Staff',
  },
  {
    id: 'students',
    value: 'Students',
    name: 'Students',
  },
]
export const MESSAGE_STATUS = {
  READ: 'read',
  UNREAD: 'unread',
}

export const MESSAGE_ACTION_TYPE = {
  INBOX: 'inbox',
  SENT: 'sent',
  DRAFT: 'draft',
  TRASH: 'trash',
}

export const ANNOUNCEMENT_BULK_ACTION = {
  ARCHIVE: 'archive',
  DELETE: 'delete',
  UNARCHIVE: 'unArchive',
  STARRED: 'starred',
  UNSTARRED: 'unstarred',
}

export const LEARNSTAGE_LMS = 'Learnstage LMS'

export const NOTIFICATION_TYPES = {
  CORE: 'notifications',
  MESSAGE: 'messages',
  ANNOUNCEMENT: 'announcements',
}
